<template>
  <div class="row">
    <div
      class="col-sm-6 col-md-6"
      v-for="(file, index) in job_files"
      :key="index"
    >
      <a :href="file.link" download>
        <app-widget
          v-if="
            file.extention == 'pdf' ||
            file.extention == 'xls' ||
            file.extention == 'doc'
          "
          class="mb-primary"
          :type="'app-widget-with-icon'"
          :label="file.name"
          :icon="'file-text'"
        />

        <app-widget
          v-else
          class="mb-primary"
          :type="'app-widget-with-icon'"
          :label="file.name"
          :icon="'image'"
        />
      </a>
    </div>
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { axiosGet } from "../../../../../Helpers/AxiosHelper";

export default {
  data() {
    return {
      job_files: {},
    };
  },
  methods: {
    jobFiles() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      // 
      // let id = split[6].split("?")[0];
      let id = this.$attrs['props'].id;
      let url = actions.JOB_FILES + "/" + id;
      this.preLoader = true;
      axiosGet(url)
        .then((response) => {
          this.deleteLoader = false;
          this.job_files = response.data;
          
          // this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          // Trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },
  },
  mounted() {
    this.jobFiles();
  },
};
</script>
